import { items } from "@wix/data";

export class VolumeDiscountUserRepository {
 
  constructor(args) {
    this._collectionId = `${args.namespace}/VolumeDiscountsUser`;
  }

  
  async create(user) {
    return items.insert(this._collectionId, user);
  }

 
  async getAll() {
    return items.query(this._collectionId).find();
  }

  async getSettings() {
    const users = await this.getAll();

    return (
      users.items[0]?.settings || {
        isHowToUseOpen: true,
      }
    );
  }

  
  async updateSettings(args) {
    const users = await this.getAll();

    if (users.items.length <= 0) {
      return null;
    }

    const user = users.items[0];

    return items.update(this._collectionId, {
      ...user,
      settings: args.settings,
    });
  }
}
